import VueRouter from 'vue-router';
import auth from './auth';

export default function decorate(router: VueRouter) {
  auth(router);
}
